const BOOK_USER_INFO_KEY = 'book_user_info_key'

export const getUserInfo = () => {
  const result = localStorage.getItem(BOOK_USER_INFO_KEY)
  return result ? JSON.parse(result) : { token: '', id: '', username: '', expireTime: '', loginTime: '' }
}

export const setUserInfo = (obj) => {
  localStorage.setItem(BOOK_USER_INFO_KEY, JSON.stringify(obj))
}

export const removeUserInfo = () => {
  localStorage.removeItem(BOOK_USER_INFO_KEY)
}
